import { render, staticRenderFns } from "./schoolSwitch2.vue?vue&type=template&id=16393bfe&scoped=true&"
import script from "./schoolSwitch2.vue?vue&type=script&lang=js&"
export * from "./schoolSwitch2.vue?vue&type=script&lang=js&"
import style0 from "./schoolSwitch2.vue?vue&type=style&index=0&id=16393bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16393bfe",
  null
  
)

export default component.exports